import { Button, Card, Tabs } from 'antd'
import useGetStockBillList from '../hooks/useGetStockBillList'
import useShowStockBillDetail from '../hooks/useShowStockBillDetail'
import useBatchOperateSelectedItem from '../hooks/useBatchOperateSelectedItem'
import { DownloadOutlined } from '@ant-design/icons'
import BillBasicTable from './StockBillBasicTable'
import BillSearchBasicForm from './StockBillSearchBasicForm'
import AuthComponent from '../../../components/AuthComponent'
import { inventoryType, inventoryTypeEnum } from '../config'
import { TypeContext } from '../context/typs'
import { useEffect, useState } from 'react'
import useStockBillTypeContext from '../hooks/useStockBillTypeContext'
function BillMainContent() {
  const { type, baseQueryModule, no, stockType } = useStockBillTypeContext()
  const tabs = [
    {
      title: '全部',
      value: ''
    },
    ...inventoryType[type].list
  ].map(item => {
    return {
      key: item.value,
      tab: item.title
    }
  })
  const [activeKey, setActiveKey] = useState(stockType)
  const { pageData, getList, loading } = useGetStockBillList(type, activeKey)
  const { BillDetailNode, showDetail } = useShowStockBillDetail()
  const queryBaseList = ({ formData }) => {
    getList({
      formData: { ...formData, stockType: activeKey || null }
    })
  }
  const { exportSelectedItems, setSelectedItems, selectedRowKeys } =
    useBatchOperateSelectedItem(pageData)
  const exportBtn = (
    <AuthComponent authKey={baseQueryModule.baseQueryPath + 'export'}>
      <Button
        icon={<DownloadOutlined />}
        type='primary'
        onClick={exportSelectedItems}>
        导出
      </Button>
    </AuthComponent>
  )
  return (
    <TypeContext.Provider value={{ type: type, no: no }}>
      <Tabs activeKey={activeKey} onChange={setActiveKey}>
        {tabs.map(item => (
          <Tabs.TabPane tab={item.tab} key={item.key}></Tabs.TabPane>
        ))}
      </Tabs>
      <BillSearchBasicForm
        stockType={activeKey}
        billType={type}
        getList={queryBaseList}>
        {exportBtn}
      </BillSearchBasicForm>
      <Card style={{ marginTop: 20 }}>
        <BillBasicTable
          type={type}
          getList={getList}
          rowSelection={{ onChange: setSelectedItems, selectedRowKeys }}
          getDetail={(text, record) => showDetail(record)}
          pageData={pageData}
          loading={loading}
        />
        {BillDetailNode}
      </Card>
    </TypeContext.Provider>
  )
}
export default BillMainContent
